var $ = window.jQuery

export default function () {
  var today = new Date()

  let day = ('0' + today.getDate()).slice(-2)
  let month = ('0' + today.getMonth()).slice(-2)
  let year = today.getFullYear()

  let hours = ('0' + today.getHours()).slice(-2)
  let minutes = ('0' + today.getMinutes()).slice(-2)

  const $dateInput = $('#manual-date').find('input:enabled')

  if (!$dateInput.val().length) {
    $dateInput.val(year + '-' + month + '-' + day + ' ' + hours + ':' + minutes)
  }
}
